
<div class="total-panel mt-2 secondary lighten-4" v-if="statistic" style="position: relative">
    <div style="height: 6px; margin-bottom: 4px;">
        <v-progress-linear
            v-if="loading"
            indeterminate
            color  = "primary"
            height = "6"
            class  = "w-100"

        />
    </div>
    <div class="total-title primary white--text" v-html="$t('todo.unit.title')" >
    </div>
    <div>
        <v-switch
            class   = "ml-2 mr-2 mt-2"
            v-model = "todoState.allCustomer"
            label   = "Alle Kunden"
            :ripple = "false"
            @change = "onAll"
            hide-details
            dense
        />
    </div>
    <div>
        <c-customer-select
            label="Kunde"
            :clearable    = "true"
            :my-customers = "!todoState.allCustomer"
            :lim-customer = "todoState.allCustomer"
            :hide-details = "true"
            v-model       = "todoState.selectedCustomer"
            class         = "ml-2 mr-2 mt-0"
            @change       = "onCustomer"
        />
    </div>
    <div class="total-circle secondary lighten-2 white--text mt-12 ml-5 mr-5">
        <div>{{ statistic.total }}</div>
        <div class="total-circle-sub mt-n3">{{ $t('todo.unit.lim.terminated') }}</div>
        <div class="total-circle-sub mt-n1">{{ statistic.terminated }}</div>
    </div>
    <div class="total-subtitle secondary white--text mt-16">
        <div>{{ $t('todo.unit.digitilized') }}</div>
        <div class="mt-n4">
            <span>{{ statistic.digitized }}</span><span style="font-size: smaller"> ({{ percentage(statistic.digitizedPercentage) }})</span>
        </div>
    </div>
    <a @click = "onMails" class="white--text" v-if="bounced.total > 0">
        <div class="total-mail warning white--text mt-16 " style="position: absolute;width: 100%;bottom: 0;}">
            <div>{{ $t('todo.unit.bounced') }}</div>
            <div class="mt-n4">
                <span>{{ bounced.total }}</span><span style="font-size: smaller"> ({{ bounced.userTotal }})</span>
            </div>
        </div>
    </a>
</div>
